export default __webpack_public_path__ + "static/media/add-icon-blue.ecc678e7.svg";